// components/SuccessMessage.jsx

import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const SuccessMessage = ({ schoolName }) => {
    const navigate = useNavigate();

    const handleGoToDashboard = () => {
        navigate('/'); // or '/dashboard' if that's your home page
      };
  return (
    <div className="bg-slate-900 text-white p-8 rounded-lg shadow-lg text-center border border-emerald-600">
      <CheckCircleIcon className="mx-auto h-16 w-16 text-emerald-500 mb-4" />
      <h2 className="text-2xl font-bold mb-2">🎉 Registration Successful!</h2>
      <p className="text-gray-300 mb-4">
        Thank you for registering <span className="text-white font-medium">{schoolName}</span> with Isnartech ERP.
      </p>
      <p className="text-gray-400">
        We've sent login credentials and further instructions to your registered email address.
      </p>
      <button
        onClick={handleGoToDashboard}
        className="mt-6 px-5 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md font-medium"
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default SuccessMessage;
